import armAcrossChest from './arm-across-chest.png'
import cuppingEar from './cupping-ear.png'
import fingerOnNose from './finger-on-nose.png'
import flatHandCarryingPlatter from './flat-hand-carrying-platter.png'
import frownThumbsDown from './frown-thumbs-down.png'
import flexingArm from './flexing-arm.png'
import handOnHead from './hand-on-head.png'
import handOverHeart from './hand-over-heart.png'
import handRaisedOath from './hand-raised-oath.png'
import hangLooseGesture from './hang-loose-gesture.png'
import kissyFace from './kissy-face.png'
import peaceSignOverEye from './peace-sign-over-eye.png'
import puffedCheeksWideEyes from './puffed-cheeks-wide-eyes.png'
import smileFourFingers from './smile-four-fingers.png'
import smileTongueOut from './smile-tongue-out.png'
import surprisedMouthCover from './surprised-mouth-cover.png'
import tongueOutSide from './tongue-out-side.png'
import twoFingerSalute from './two-finger-salute.png'
import wink from './wink.png'
import zeroOverEye from './zero-over-eye.png'

export {
  armAcrossChest,
  cuppingEar,
  fingerOnNose,
  flatHandCarryingPlatter,
  frownThumbsDown,
  flexingArm,
  handOnHead,
  handOverHeart,
  handRaisedOath,
  hangLooseGesture,
  kissyFace,
  peaceSignOverEye,
  puffedCheeksWideEyes,
  smileFourFingers,
  smileTongueOut,
  surprisedMouthCover,
  tongueOutSide,
  twoFingerSalute,
  wink,
  zeroOverEye
}